(()=>{
  function bind(root){
    root.querySelectorAll('[data-ss-addon-card]').forEach(card=>{
      const button=card.querySelector('[data-ss-addon-add]');
      if(!button||button.dataset.ssAddonReady)return;
      button.dataset.ssAddonReady='true';
      const status=card.querySelector('[data-ss-addon-status]'),label=button.querySelector('span'),icon=button.querySelector('svg path'),picker=card.querySelector('[data-ss-addon-variant]'),added=new Set();
      function render(){
        const done=added.has(button.dataset.ssAddonAdd);
        button.disabled=done;
        button.classList.toggle('is-added',done);
        label.textContent=done?'Added':'Add';
        icon.setAttribute('d',done?'m3 8 3 3 7-7':'M8 3v10M3 8h10');
        button.setAttribute('aria-label',done?button.dataset.name+' added to cart':'Add '+button.dataset.name+(picker?' · '+picker.selectedOptions[0].textContent:'')+' to cart');
      }
      picker?.addEventListener('change',()=>{
        const option=picker.selectedOptions[0];
        if(!option||option.disabled)return;
        button.dataset.ssAddonAdd=option.value;
        card.querySelector('[data-ss-addon-price]').textContent=option.dataset.price;
        const original=card.querySelector('[data-ss-addon-original-price]');
        if(original){original.textContent=option.dataset.originalPrice;original.hidden=option.dataset.hasOffer!=='true';}
        const img=card.querySelector('.ss-addon-image');
        if(img&&option.dataset.image){img.src=option.dataset.image;img.removeAttribute('srcset');}
        status.textContent='';status.classList.remove('is-error');render();
      });
      button.addEventListener('click',async()=>{
        if(button.disabled)return;
        const variant=button.dataset.ssAddonAdd;
        button.disabled=true;button.setAttribute('aria-busy','true');label.textContent='Adding';
        if(picker)picker.disabled=true;
        status.textContent='';status.classList.remove('is-error');
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1,...(card.dataset.ssPdpOffer==='bible-addons-v1'?{properties:{_ss_pdp_offer:'bible-addons-v1'}}:{})}]})});
          const data=await response.json();
          if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'Could not add this item. Please try again.');
          added.add(variant);status.textContent='Added to your cart';
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'ss-bible-addons',items:data.items}}));
        }catch(error){status.textContent=error.message||'Could not add this item. Please try again.';status.classList.add('is-error');}
        finally{button.removeAttribute('aria-busy');if(picker)picker.disabled=false;render();}
      });
      render();
    });
  }
  document.querySelectorAll('[data-ss-addon-disclosure]').forEach(bind);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ss-addon-disclosure]').forEach(bind));
})();
